import { render, staticRenderFns } from "./page-blog.vue?vue&type=template&id=5c3b3d31&scoped=true"
import script from "./page-blog.vue?vue&type=script&lang=js"
export * from "./page-blog.vue?vue&type=script&lang=js"
import style0 from "./page-blog.vue?vue&type=style&index=0&id=5c3b3d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b3d31",
  null
  
)

export default component.exports